import slideshow from './slideshow'

export default () => {
  slideshow()
}


// WEBPACK FOOTER //
// ./scripts/steroids/index.js